import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router
} from '@angular/router';
import { StorageService } from '../services/storage.service';
import { WindowRef } from "../helpers/windowRef.service";
import { isPlatformBrowser } from "@angular/common";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router,
              @Inject(PLATFORM_ID) private platformId: any,
              private windowRef: WindowRef) {
    StorageService.platformId = platformId;
    StorageService.windowRef = windowRef;
  }

  canActivate(
      next: ActivatedRouteSnapshot,
      state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const lang = next.params['lang'] || 'en'; // Get lang from URL params, default to 'en'
    const homeUrl = `/${lang}`; // Home page URL
    const signInUrl = `/${lang}/auth/signin`; // Sign-in page URL

    let token;
    if (isPlatformBrowser(this.platformId)) {
      token = StorageService.getItem(StorageService.statics.token);
    }

    if (!token) {
      // If user is not logged in, redirect them to sign-in page (except if already on sign-in page)
      if (state.url !== signInUrl) {
        if(isPlatformBrowser(this.platformId)){
          this.router.navigate([signInUrl]);
        }
      }
      return false;
    }

    const currentUser = StorageService.getJsonItem(StorageService.statics.currentUser);

    if (!currentUser || ['blocked', 'inactive', 'deleted'].includes(currentUser.status)) {
      StorageService.removeItem(StorageService.statics.token);
      StorageService.removeItem(StorageService.statics.profileData);
      alert('Your account is not active. Please contact support.');
      this.router.navigate([signInUrl]);
      return false;
    }

    // If the user is already on the sign-in page and logged in, redirect to home page
    if (state.url === signInUrl) {
      this.router.navigate([homeUrl]);
      return false;
    }

    return true; // Allow access to the requested page
  }
}
